import {
  CreateUpdateFieldTranslationsRequest,
  FieldResponse,
  FieldTranslationsResponse,
  FieldValuesResponse,
  LoadFieldValuesFromFileRequest,
  LoadFieldValuesRequest
} from '@cs-cms/types';
import { ExecuteEndpoint } from '../base/BaseApiService';

export class FieldsService {
  public async getAllFields(locale?: string, indexId?: number): Promise<FieldResponse[]> {
    const searchParams = new URLSearchParams();
    if (locale) {
      searchParams.append('locale', locale);
    }
    if (indexId !== undefined) {
      searchParams.append('indexId', indexId.toString());
    }
    const queryParams = searchParams.size > 0 ? `?${searchParams.toString()}` : '';

    return ExecuteEndpoint(`fields${queryParams}`, 'GET');
  }

  public async loadFieldValues(fieldId: number, request: LoadFieldValuesRequest): Promise<FieldValuesResponse> {
    return ExecuteEndpoint(`fields/${fieldId}/load-values`, 'POST', { json: request });
  }

  public async loadFieldValuesFromFile(request: LoadFieldValuesFromFileRequest): Promise<FieldValuesResponse> {
    const formData = new FormData();

    request.fileList.forEach(file => {
      formData.append('FileList', file);
    });

    const metadataJson = JSON.stringify({
      Data: {
        ContentTypeName: request.data.contentTypeName,
        Metadata: request.data.metadata
      }
    });
    formData.append('Metadata', metadataJson);

    return ExecuteEndpoint(`fields/files/load-values-from-file`, 'POST', { body: formData });
  }

  public async getFieldTranslations(indexId: number, localeId: number): Promise<FieldTranslationsResponse> {
    const queryParams = new URLSearchParams();

    queryParams.append('indexId', indexId.toString());
    queryParams.append('localeId', localeId.toString());

    return ExecuteEndpoint(`fields/translations?${queryParams}`, 'GET');
  }

  public async createUpdateFieldTranslations(request: CreateUpdateFieldTranslationsRequest): Promise<string> {
    return ExecuteEndpoint(`fields/translations`, 'POST', { json: request });
  }
}
